import MaterialsIcon from "assets/menu-icons/MaterialsIcon";

// Раздел доступен всем, в том числе неподтверждённому пользователю: это публичные
// документы клиники, медицинских данных пациента в нём нет.
// В меню стоит последним - так в макете.
const materials = {
  id: 'materials',
  type: 'group',
  visible: true,
  children: [{
    id: 'materials',
    title: 'Материалы',
    type: 'item',
    url: '/materials',
    icon: MaterialsIcon,
    breadcrumbs: false,
    visible: true,
  }]
}

export default materials;
